import {
  addAppResumeListener,
  addAppUrlOpenListener,
  type AppListenerHandle,
} from "@src/appV2/NativeAdapters/app.adapter";
import { useQueryClient } from "@tanstack/react-query";
import { useEffect } from "react";

import { APP_V2_USER_EVENTS } from "../../lib/analytics/events";
import { logEvent } from "../../lib/analytics/log";
import { invalidateShifts } from "../invalidateShifts";

export function useInvalidateShiftsOnDeeplink() {
  const queryClient = useQueryClient();

  useEffect(() => {
    let urlOpenListener: Promise<AppListenerHandle> | undefined;
    let resumeListener: Promise<AppListenerHandle> | undefined;

    async function setupListeners() {
      urlOpenListener = addAppUrlOpenListener(() => {
        logEvent(APP_V2_USER_EVENTS.SHIFTS_INVALIDATED_ON_DEEPLINK);

        void invalidateShifts(queryClient);
      });

      resumeListener = addAppResumeListener(() => {
        logEvent(APP_V2_USER_EVENTS.SHIFTS_INVALIDATED_ON_APP_RESUMED);

        void invalidateShifts(queryClient);
      });
    }

    void setupListeners();

    return () => {
      // eslint-disable-next-line promise/prefer-await-to-then
      void urlOpenListener?.then(async (listener) => {
        await listener?.remove();
      });

      // eslint-disable-next-line promise/prefer-await-to-then
      void resumeListener?.then(async (listener) => {
        await listener?.remove();
      });
    };
  }, [queryClient]);
}
